import { CommonModule } from '@angular/common';
import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { RadioButtonClickEvent, RadioButtonModule } from 'primeng/radiobutton';

@Component({
  selector: 'app-custom-radiobutton',
  templateUrl: './custom-radiobutton.component.html',
  styleUrls: ['./custom-radiobutton.component.scss'],
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomRadiobuttonComponent),
      multi: true
    }
  ],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RadioButtonModule]
})
export class CustomRadiobuttonComponent implements OnInit {
  onChange: (value: number) => void = () => { };
  onTouched: () => void = () => { };
  disabled: boolean = false;
  value: number = 0;

  @Input() listRadioButtons: { label: string, value: number }[] = [];
  @Input() labelText: string = "";
  @Input() classContainer: string = "";
  @Input() required: boolean = false;
  @Output() onChangeRadioButton = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  changeRadioButton(event: RadioButtonClickEvent) {
    this.value = event.value;
    this.onChange(this.value);
    this.onTouched();
    this.onChangeRadioButton.emit(this.value);
  }

  registerOnChange(fn: (value: number) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(value: number): void {
    this.value = value;
  }
}
